import { useEffect, useState } from "react";
import type { BusinessView } from "../../features/businesses/api.js";
import { Icon } from "./Icon.js";
import styles from "./StatusPill.module.css";

/**
 * Live connection status pill (doc 01 §1.2). Phase 1 placeholder: shows the
 * active brand's connection/quality/tier from the businesses query + a 30s clock.
 * Real tier/quality come live in Phase 2 via the WABA read-through.
 */
export function StatusPill({ business }: { business: BusinessView | undefined }) {
  const [now, setNow] = useState(() => "—:—");
  useEffect(() => {
    const fmt = () =>
      new Intl.DateTimeFormat("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        timeZone: "Asia/Kuala_Lumpur",
      }).format(new Date());
    setNow(fmt());
    const t = setInterval(() => setNow(fmt()), 30_000);
    return () => clearInterval(t);
  }, []);

  const connected = business?.connected ?? false;
  const quality = business?.quality ?? "unknown";
  const tier = business?.tier ?? 0;

  return (
    <div className={`${styles.pill} t-mono`} data-connected={connected}>
      <span className={styles.dot} data-quality={quality}>
        <Icon name="dot" size={10} />
      </span>
      <span>{connected ? "Connected" : "Setup pending"}</span>
      <span className={styles.sep}>·</span>
      <span title="Quality rating">{quality}</span>
      <span className={styles.sep}>·</span>
      <span title="Daily tier">{tier ? `${tier.toLocaleString()}/day` : "—"}</span>
      <span className={styles.sep}>·</span>
      <span>{now}</span>
    </div>
  );
}
